import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const forWho = ['Profesionales con altos niveles de estrés que sienten pesadez constante.', 'Personas que notan su vientre mucho más inflamado por la tarde que por la mañana.', 'Quienes tienen un evento importante en 3 días y necesitan que su ropa les quede perfecta.', "Hombres y mujeres de 35+ que sienten que su metabolismo se ha 'atascado'."];
  const notForWho = ['Personas que buscan una dieta de pérdida de peso a largo plazo (esto es un reseteo de emergencia).', 'Quienes no están dispuestos a dejar el café o el pan por solo 72 horas.', 'Atletas de alto rendimiento en medio de una competición.'];
  return <section className="bg-off-white py-20 px-4" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-178">
          {/* Para quién es */}
          <div className="bg-sage/10 p-8 md:p-10 border border-sage/30" data-id="element-179">
            <h3 className="text-2xl font-serif text-dark-green mb-8" data-id="element-180">
              Este protocolo ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-181">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-182">
                  <Check className="w-5 h-5 text-dark-green mr-3 mt-1 flex-shrink-0" data-id="element-183" />
                  <span className="font-sans text-gray-700 leading-relaxed" data-id="element-184">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-white p-8 md:p-10 border border-gray-200" data-id="element-185">
            <h3 className="text-2xl font-serif text-gray-400 mb-8" data-id="element-186">
              Este protocolo NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-187">
              {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-188">
                  <X className="w-5 h-5 text-gray-400 mr-3 mt-1 flex-shrink-0" data-id="element-189" />
                  <span className="font-sans text-gray-500 leading-relaxed" data-id="element-190">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}